import React, { useMemo, useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { ClientPaymentPlanView } from '../components/payment-plans/ClientPaymentPlanView';
import { PlanView } from '../components/payment-plans/PlanView';
import { DateRangeFilter } from '../components/payment-plans/DateRangeFilter';
import { SearchIcon, FilterIcon, DownloadIcon, PlusIcon, UsersIcon, ClipboardListIcon } from 'lucide-react';
export function PianiRientro() {
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState<'client' | 'plan'>('client');
  const [dateRange, setDateRange] = useState<{
    start: Date | null;
    end: Date | null;
    preset?: string;
  }>({
    start: null,
    end: null,
    preset: 'all'
  });
  const [sortField, setSortField] = useState<string>('dataCreazione');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  // Funzione per gestire il cambio di ordinamento
  const handleSort = (field: string) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  return <div className="space-y-6 pb-16" data-id="element-2227">
      <div data-id="element-2228">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2229">
          Piani di Rientro
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-2230">
          Gestisci e monitora i piani di rientro accordati con i clienti.
        </p>
      </div>
      <Card data-id="element-2231">
        <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:justify-between mb-4" data-id="element-2232">
          <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:space-x-4" data-id="element-2233">
            <div className="relative flex-1 max-w-md" data-id="element-2234">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-2235">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-2236" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Cerca per cliente, importo, stato..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-2237" />
            </div>
            <DateRangeFilter dateRange={dateRange} onChange={setDateRange} data-id="element-2238" />
          </div>
          <div className="flex space-x-2" data-id="element-2239">
            <div className="inline-flex rounded-md shadow-sm" data-id="element-2240">
              <button type="button" className={`relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 text-sm font-medium ${viewMode === 'client' ? 'bg-blue-50 text-blue-700 border-blue-500 z-10' : 'bg-white text-gray-700 hover:bg-gray-50'}`} onClick={() => setViewMode('client')} data-id="element-2241">
                <UsersIcon className="h-4 w-4 mr-2" data-id="element-2242" />
                Per Cliente
              </button>
              <button type="button" className={`relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 text-sm font-medium ${viewMode === 'plan' ? 'bg-blue-50 text-blue-700 border-blue-500 z-10' : 'bg-white text-gray-700 hover:bg-gray-50'}`} onClick={() => setViewMode('plan')} data-id="element-2243">
                <ClipboardListIcon className="h-4 w-4 mr-2" data-id="element-2244" />
                Per Piano
              </button>
            </div>
            <button className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-2245">
              <DownloadIcon className="h-4 w-4 mr-2" data-id="element-2246" />
              Esporta
            </button>
            <Button icon={<PlusIcon className="h-4 w-4 mr-2" data-id="element-2248" />} data-id="element-2247">
              Nuovo Piano
            </Button>
          </div>
        </div>
        {viewMode === 'client' ? <ClientPaymentPlanView searchTerm={searchTerm} dateRange={dateRange} sortField={sortField} sortDirection={sortDirection} onSort={handleSort} data-id="element-2249" /> : <PlanView searchTerm={searchTerm} dateRange={dateRange} sortField={sortField} sortDirection={sortDirection} onSort={handleSort} data-id="element-2250" />}
      </Card>
    </div>;
}